import repository from './repository';
import { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
const dataInit = {
    oldPassword: '',
    newPassword: '',
    newPasswordConfirm: ''
};
export default {
    namespaced: true,
    state: {
        data: {
            ...dataInit
        },
        authorityOptions: [
            {
                code: 0,
                name: '一般'
            },
            {
                code: 1,
                name: '管理者'
            }
        ]
    },
    mutations: {
        setData(state, data) {
            state.data = data ?? { ...dataInit };
        },
        resetData(state) {
            state.data = { ...dataInit };
        }
    },
    actions: {
        changePassWord(context, input) {
            const authorityNumber = localStorage.getItem('authority');
            if (authorityNumber) {
                this.authority = JSON.parse(authorityNumber);
            }
            try {
                if (this.authority == 2) {
                    repository.PopupChangePassWordMNG(input.body).then((res) => {
                        const { data } = res;
                        if (data.Code == 200) {
                            if (input.callback) {
                                input.callback(data.Data);
                            }
                        } else if (data.Code == 422) {
                            this.commit('app/showModalMessage', {
                                type: MSG_TYPE.ERROR,
                                title: MSG_TITLE.E001,
                                content: data.Message[0],
                                okText: 'OK'
                            });
                        } else {
                            if (input.onError) {
                                input.onError(data.Data.message);
                            }
                        }
                    });
                } else {
                    repository.PopupChangePassWordCUS(input.body).then((res) => {
                        const { data } = res;
                        if (data.Code == 200) {
                            if (input.callback) {
                                input.callback(data.Data);
                            }
                        } else if (data.Code == 422) {
                            console.log(data.Message);
                            this.commit('app/showModalMessage', {
                                type: MSG_TYPE.ERROR,
                                title: MSG_TITLE.E001,
                                content: data.Message[0],
                                okText: 'OK'
                            });
                        } else {
                            if (input.onError) {
                                input.onError(data.Data.message);
                            }
                        }
                    });
                }
            } catch (e) {
                console.log('searchCustomerInfo: ' + e.message);
            }
        }
    }
};
